<template>
    <div class="edit-info-panel">
        <div class="edit-info-panel-context">
            <div class="form-item">
                <div class="label">名称</div>
                <div class="input-wrapper">
                    <textarea class="info-name" v-model="title"></textarea>
                </div>
            </div>
            <div class="form-item">
                <div class="label">描述</div>
                <div class="input-wrapper">
                    <textarea class="info-description" v-model="description"></textarea>
                </div>
            </div>
        </div>
        <div class="edit-info-panel-tools">
            <!-- <span class="icon-glyphicon-plus" title="添加字段"></span> -->

            <span class="icon-glyphicon-ok" title="完成" @click="$emit('save', { title, description })"></span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EditInfoPanel',
    data() {
        return {
            title: this.item.title,
            description: this.item.description
        }
    },
    props: {
        item: {
            type: Object, // 假设 item 是对象类型，根据实际情况调整
            required: true // 表示该参数是必需的
        }
    },
    mounted() {


    },
    methods: {



    }
}

</script>

<style scoped>
.edit-info-panel {
    font-size: 14px;

}

.edit-info-panel-context {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.form-item {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    vertical-align: top;
}

.label {
    white-space: nowrap;
    padding-right: 10px;
    margin-top: 10px;
}

.input-wrapper {
    flex: 1;
}

.info-name,
.info-description {
    width: 100%;
    box-sizing: border-box;
    min-height: 50px;
    border-color: #2b542c;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    color: #555555;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #cccccc;
    border-radius: 4px;
    outline: none;
}

.info-name:focus,
.info-description:focus {
    border: 1px solid #cccccc;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #67b168;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #67b168;
}

.edit-info-panel-tools {
    font-size: 14px;
    height: 20px;
    line-height: 20px;
    margin-top: 10px;
}

.edit-info-panel-tools span {
    float: right;
    cursor: pointer;
    margin-left: 5px;
}
</style>